import {AvatarMenu, Header, Logo} from '@coolcolduk/ui-mui';
import {Menu} from '@mui/icons-material';
import {Box, Button} from '@mui/material';
import {useNavigate} from 'react-router';
import {signInWithGoogle} from '../../pages/other/LoginPage';
import {createWebsiteMenu} from '../../variables/createWebsiteMenu';
import {UserAccount} from '../../__generated__/resolvers-types';

export interface HeaderComponentProps {
  user: UserAccount | null | undefined;
}

export default function HeaderComponent({user}: HeaderComponentProps) {
  const navigate = useNavigate();

  if (user) return null;
  const items = createWebsiteMenu(navigate);
  return (
    <Header
      appBarProps={{position: 'sticky'}}
      sx={{backgroundColor: 'background.default'}}
      leftComponent={
        <Logo
          // title={SITE_TITLE}
          onClick={() => navigate('/')}
          sx={{
            '& > .CcLogo-text': {color: 'text.primary'},
            // '& > .CcLogo-img': {height: '60px'},
          }}
          logoUrl="/logo.svg"
        />
      }
      middleComponent={
        <>
          <AvatarMenu
            sx={{display: {sm: 'none', xs: 'block'}}}
            label="siteMenu"
            items={items}
            avatarComponent={<Menu />}
            // menuProps={{
            //   sx: {left: 200, top: 0},
            //   anchorOrigin: {
            //     vertical: 'bottom',
            //     horizontal: 'right',
            //   },
            //   transformOrigin: {
            //     vertical: 'bottom',
            //     horizontal: 'left',
            //   },
            // }}
          />
          <Box sx={{display: {sm: 'block', xs: 'none'}}}>
            {items.map((item) => (
              <Button
                key={`HeaderComponent-middle-${item.label}`}
                sx={{color: 'secondary.main'}}
                onClick={item.onClick}
              >
                {item.label}
              </Button>
            ))}
          </Box>
        </>
      }
      rightComponent={
        <Button variant="contained" onClick={signInWithGoogle} loading={user === undefined}>
          Sign in/Sign up
        </Button>
      }
    />
  );
}
